<template>
	<div class="dealers-projects">
		<action-sidebar
			title="Proyectos"
			:value="true"
			:width="644"
			@close-modal="closeModal"
		>
			<v-tabs 
				v-model="tabsModel"
				right
				slider-color="cyan">
				<v-tab v-for="(item, index) in tabs" :key="index">
					{{item.name}}
				</v-tab>
				<v-tabs-items>
					<v-tab-item>
						<table-assign
						:check-all="checkAll" 
						:columns="columnsProjects"
						:rows="projects"
						:selected-value="selectedValue"
						:last-page="lastPageAssigned"
						:current-page="currentPageAssigned"
						@all-is-selected="allIsSelected"
						@on-search="onSearchList"
						@row-is-selected="rowIsSelected"
						@change-page="changePageAssigned"
						/>
					</v-tab-item>
					<v-tab-item>
						<table-assign
						:check-all="checkAllDeallocated"
						:columns="columnsProjects"
						:rows="projectAssigned"
						:last-page="lastPage"
						:current-page="currentPage"
						@change-page="changePage"
						@on-search="onSearchDeallocated"
						:selected-value="selectedValueDeallocated"
						@all-is-selected="allIsSelectedDeallocated"
						@row-is-selected="rowIsSelectedDeallocated"
						/>
					</v-tab-item>
				</v-tabs-items>
			</v-tabs>
			<section class="modal-filter-footer pt-4 pb-4 center-buttons">
				<v-btn
				class="btn-action caption ml-2" 
				color="pink"
				@click="closeModal">
					Cancelar
				</v-btn>
				<v-btn
				class="btn-action caption ml-1"
				color="success"
				@click="assignRow"
				:disabled="disabledProject(1)">
					Asignar
				</v-btn>
				<v-btn 
				class="btn-action caption ml-2" 
				color="success"
				:disabled="disabledDeallocated(0)"
				@click="deallocateButton">
					Desasignar
				</v-btn>
			</section>
		</action-sidebar>
	</div>
</template>

<script>
import actionSidebar from '@/components/shared/action-sidebar';
import tableAssign from '@/components/configuration/table-assign';

function created() {
	this.listProjects();
	this.listProjectsDeallocated();
}

async function deallocateButton() {
	const ids = this.dataSelectedDeallocated.map(item => item.id);
	const body = {
		projectIds: ids,
	};
	try {
		await this.$http.delete(`distributaries/${this.id}/projects`, { data: body });
		this.listProjectsDeallocated();
		this.closeModal();
		this.showNotification('Fueron desasignados correctamente');
	} catch (error) {
		this.showError();
	}
}

function changePageAssigned(page) {
	this.params.page = page;
	this.currentPageAssigned = page;
	this.listProjects();
}

function changePage(page) {
	this.params.page = page;
	this.currentPage = page;
	this.listProjectsDeallocated();
}

function closeModal() {
	this.goTo('page-config-dealers');
}

function disabledDeallocated(value) {
	return this.tabsModel === value || this.dataSelectedDeallocated < 1;
}

function disabledProject(value) {
	return this.tabsModel === value || this.dataSelected.length < 1;
}

async function assignRow() {
	const projectIds = this.dataSelected.map(action => action.id);
	try {
		await this.$http.post(`distributaries/${this.id}/projects`, { projectIds });
		this.listProjects();
		this.closeModal();
		this.showNotification('Los proyectos fueron asignados correctamente');
	} catch (error) {
		this.showError();
	}
}

function onSearchList(value) {
	this.params.search = value ? value.trim() : null;
	this.listProjects();
}

function onSearchDeallocated(search) {
	this.params.search = search ? search.trim() : null;
	this.listProjectsDeallocated();
}

function allIsSelectedDeallocated(checked) {
	this.checkAllDeallocated = checked;
	this.dataSelectedDeallocated = [];
	this.projectAssigned = this.projectAssigned.map((item) => {
		const newRowDeallocated = { ...item };
		newRowDeallocated.isSelected = checked;
		if (checked) {
			this.dataSelectedDeallocated.push(item);
		}
		return newRowDeallocated;
	});
	this.projectAssigned = this.selectIsRow(this.projectAssigned,
		this.selectedValueDeallocated, false, checked);
}

function allIsSelected(checked) {
	this.checkAll = checked;
	this.dataSelected = [];
	this.projects = this.projects.map((element) => {
		const newRow = { ...element };
		newRow.isSelected = checked;
		if (checked) {
			this.dataSelected.push(element);
		}
		return newRow;
	});
	this.projects = this.selectIsRow(this.projects, this.selectedValue, false, checked);
}

function rowIsSelected(row) {
	this.projects = this.selectIsRow(this.projects, this.selectedValue, row);
	this.checkAll = this.every(this.projects, this.selectedValue);
	this.dataSelected = this.projects.filter(r => r.flagSelected);
}

function rowIsSelectedDeallocated(row) {
	this.projectAssigned = this.selectIsRow(this.projectAssigned, this.selectedValueDeallocated, row);
	this.checkAll = this.every(this.projectAssigned, this.selectedValueDeallocated);
	this.dataSelectedDeallocated = this.projectAssigned.filter(r => r.flag);
}

async function listProjects() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 30,
		isSelected: 0,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/projects`, { params });
		this.projects = response.data.data;
		this.lastPageAssigned = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

async function listProjectsDeallocated() {
	const params = {
		page: this.params.page,
		search: this.params.search,
		perPage: 30,
		isSelected: 1,
	};
	try {
		const response = await this.$http.get(`distributaries/${this.id}/projects`, { params });
		this.projectAssigned = response.data.data;
		this.lastPage = Number(response.headers['x-last-page']);
	} catch (error) {
		this.showError();
	}
}

function data() {
	return {
		actionParams: {
			codeProject: '',
			resourceId: 0,
		},
		checkAll: false,
		checkAllDeallocated: false,
		columnsProjects: [
			{ id: 1, name: 'Nombre', value: 'name', checked: true, visible: true },
			{ id: 2, name: 'Descripción', value: 'description', checked: true, visible: true },
			{ id: 3, name: 'Código de proyecto', value: 'code', checked: true, visible: true },
		],
		currentPage: 1,
		currentPageAssigned: 1,
		dataSelected: [],
		dataSelectedDeallocated: [],
		lastPage: 0,
		lastPageAssigned: 0,
		rowAssigned: [],
		params: {
			page: 1,
		},
		projectAssigned: [],
		projectId: null,
		projects: [],
		tabs: [
			{
				id: 1,
				name: 'Asignar',
			},
			{
				id: 2,
				name: 'Asignados',
			},
		],
		tabsModel: null,
		selectedValue: 'flagSelected',
		selectedValueDeallocated: 'flag',
	};
}

export default {
	name: 'page-projects',
	created,
	data,
	components: {
		actionSidebar,
		tableAssign,
	},
	methods: {
		rowIsSelectedDeallocated,
		allIsSelectedDeallocated,
		allIsSelected,
		assignRow,
		changePage,
		changePageAssigned,
		closeModal,
		deallocateButton,
		disabledDeallocated,
		disabledProject,
		listProjects,
		listProjectsDeallocated,
		rowIsSelected,
		onSearchList,
		onSearchDeallocated,
	},
	props: {
		id: {
			type: [Number, String],
		},
	},
};
</script>

<style lang="scss" scoped>
.center-buttons {
	display: flex;
	justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuration/page-projects.vue